import React, { useState } from "react";

const ContactForm = () => {
    const [form, setForm] = useState({
        name: "",
        email: "",
        type: "Landing",
        budget: "",
        message: "",
      });
      const [fileName, setFileName] = useState(null);
      const [submitting, setSubmitting] = useState(false);
      const [success, setSuccess] = useState(null);
      const [consent, setConsent] = useState(false);
      const [errors, setErrors] = useState({});
    
      function handleChange(e) {
        const { name, value } = e.target;
        setForm((s) => ({ ...s, [name]: value }));
      }
    
      function handleFile(e) {
        const f = e.target.files && e.target.files[0];
        if (f) {
          setFileName(f.name);
        } else {
          setFileName(null);
        }
      }
    
      function validate() {
        const err = {};
        if (!form.name.trim()) err.name = "Please enter your name.";
        if (!form.email.match(/^\S+@\S+\.\S+$/)) err.email = "Please enter a valid email.";
        if (!consent) err.consent = "Please accept data processing (GDPR).";
        if (!form.message.trim()) err.message = "Please describe your project briefly.";
        setErrors(err);
        return Object.keys(err).length === 0;
      }
    
      async function handleSubmit(e) {
        e.preventDefault();
        if (!validate()) return;
        setSubmitting(true);
        setErrors({});
        setSuccess(null);
    
        /* --- Example: submit to Formspree ---
           1) Create a form at https://formspree.io/ (free tier available).
           2) Replace YOUR_FORMSPREE_ENDPOINT below with your endpoint (looks like https://formspree.io/f/xyz...)
           3) This sends form data as JSON. You can also submit a native form POST.
        */
        try {
          const endpoint = "https://formspree.io/f/YOUR_FORMSPREE_ENDPOINT"; // <-- replace this
          const payload = {
            name: form.name,
            email: form.email,
            projectType: form.type,
            budget: form.budget,
            message: form.message,
          };
    
          const res = await fetch(endpoint, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify(payload),
          });
    
          if (!res.ok) throw new Error("Network response was not ok");
    
          setSuccess("Thanks — your message has been sent. I'll reply within 24 hours.");
          setForm({ name: "", email: "", type: "Landing", budget: "", message: "" });
          setFileName(null);
          setConsent(false);
        } catch (err) {
          console.error(err);
          setSuccess("There was a problem sending your message. Please email hello@yourdomain.com directly.");
        } finally {
          setSubmitting(false);
        }
      }
  return (

          <form className="card p-3 shadow-sm" onSubmit={handleSubmit} noValidate>
            <div className="mb-3">
              <label className="form-label">Your name</label>
              <input
                name="name"
                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                value={form.name}
                onChange={handleChange}
                required
              />
              <div className="invalid-feedback">{errors.name}</div>
            </div>

            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                name="email"
                type="email"
                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                value={form.email}
                onChange={handleChange}
                required
              />
              <div className="invalid-feedback">{errors.email}</div>
            </div>

            <div className="row g-2 mb-3">
              <div className="col-sm-7">
                <label className="form-label">Project type</label>
                <select name="type" className="form-select" value={form.type} onChange={handleChange}>
                  <option>Landing</option>
                  <option>SPA / Dashboard</option>
                  <option>E-commerce</option>
                  <option>Other</option>
                </select>
              </div>
              <div className="col-sm-5">
                <label className="form-label">Budget (approx.)</label>
                <select name="budget" className="form-select" value={form.budget} onChange={handleChange}>
                  <option value="">Select</option>
                  <option>€300 - €600</option>
                  <option>€900 - €2500</option>
                  <option>€2500+</option>
                </select>
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label">Project details</label>
              <textarea
                name="message"
                className={`form-control ${errors.message ? "is-invalid" : ""}`}
                rows="4"
                value={form.message}
                onChange={handleChange}
                required
              />
              <div className="invalid-feedback">{errors.message}</div>
            </div>

            <div className="mb-3">
              <label className="form-label">Attach a file (optional)</label>
              <input name="attachment" type="file" className="form-control" onChange={handleFile} />
              {fileName && <small className="form-text text-muted">Selected: {fileName}</small>}
            </div>

            <div className="mb-3 form-check">
              <input
                id="consent"
                className={`form-check-input ${errors.consent ? "is-invalid" : ""}`}
                type="checkbox"
                checked={consent}
                onChange={() => setConsent((c) => !c)}
              />
              <label className="form-check-label" htmlFor="consent">
                I consent to having this website store my submitted information so we can respond. (GDPR)
              </label>
              <div className="invalid-feedback">{errors.consent}</div>
            </div>

            <div className="d-grid">
              <button type="submit" className="btn btn-primary btn-lg rounded-pill" disabled={submitting}>
                {submitting ? "Sending..." : "Send message"}
              </button>
            </div>

            {success && (
              <div className="alert alert-info mt-3 mb-0" role="alert">
                {success}
              </div>
            )}
          </form>

  )
}

export default ContactForm